import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import arrayGroupBy from 'src/utils/arrayGroupBy';
import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';

const TableSegmentsMarketShare = ({
  array = [],
  selectedDate,
  title = '',
  param,
  order,
  enableDate = false,
  sizeHeader = 2,
}) => {
  // normalizo los

  const orderParams = array.reduce((newArray, a) => {
    const found = newArray.find((param) => param === a[order]);
    if (found === undefined) newArray.push(a[order]);
    return newArray;
  }, []);

  // normalizo los segmentos
  const orderCompanys = array.reduce((newArray, a) => {
    const found = newArray.find((company) => company === a[param]);
    if (found === undefined) newArray.push(a[param]);
    return newArray;
  }, []);

  // normalizo el tamaño del segmento
  let tableArray = [];
  tableArray = arrayGroupBy(array, param);
  tableArray.forEach((value, index) => {
    orderParams.forEach((parameter) => {
      const found = value.findIndex((item) => item.SEGMENTO === parameter);
      if (found === -1) {
        tableArray[index].push({
          [param]: value[0][param],
          [order]: parameter,
          DIFMS: 0,
          MS1: 0,
          MS2: 0,
          VALOR1: 0,
          VALOR2: 0,
          VS: 0,
        });
      }
    });
  });

  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="spanning table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">SEGMENTO</StyledTableCell>
              {orderCompanys.map((row) => (
                <>
                  <StyledTableCell colSpan={sizeHeader} align="center">
                    {row}
                  </StyledTableCell>
                </>
              ))}
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              {orderCompanys.map(() => (
                <>
                  <StyledTableCell align="right">
                    {selectedDate.getFullYear()}
                  </StyledTableCell>
                  {enableDate && (
                  <StyledTableCell align="right">
                    {selectedDate.getFullYear() - 1}
                  </StyledTableCell>
                  )}
                  <StyledTableCell align="right">
                    {selectedDate.getFullYear()}
                    vs
                    {selectedDate.getFullYear() - 1}
                  </StyledTableCell>
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {orderParams.map((rowTitle, index) => (
              <TableRow key={Math.random()}>
                <TableCell align="left">{rowTitle.toUpperCase()}</TableCell>
                {tableArray.map((cell) => (
                  <>
                    <TableCell align="right">
                      {currencyFormat(
                        parseInt(cell[index].VALOR1 || 0, 10),
                      )}
                    </TableCell>
                    {enableDate && (
                      <TableCell align="right">
                        {currencyFormat(
                          parseInt(cell[index].VALOR2 || 0, 10),
                        )}
                      </TableCell>
                    )}
                    <TableCell align="right">
                      {(+cell[index].VS || 0 * 100).toFixed(2)}
                      %
                    </TableCell>
                  </>
                ))}
              </TableRow>
            ))}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              {tableArray.map((cell) => (
                <>
                  <TableCell align="right">
                    {onMouseResultsMap.totals(cell, 'VALOR1')}
                  </TableCell>
                  {enableDate && (
                  <TableCell align="right">
                    {onMouseResultsMap.totals(cell, 'VALOR2')}
                  </TableCell>
                  )}
                  <TableCell align="right"> </TableCell>
                </>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableSegmentsMarketShare;
